<template>
    <section class="formations-list">
        <div class="container">
            <div class="content-wrapper">
                <slot></slot>
                <div id="anchorReset"></div>
                <div data-sticky-container>
                    <div class="filters-wrappers">
                        <custom-select
                                v-if="breakpointDownMd"
                                :options="filters"
                                v-model="activeFilter"
                                valueField="slug"
                                labelField="name"
                        ></custom-select>
                        <ul class="filters" v-else>
                            <li v-for="(filter, index) in filters">
                                <a href="" @click.prevent="selectFilter(filter)"
                                   :class="{active: filter.slug === activeFilter}"><span>{{filter.name}}</span></a>
                            </li>
                        </ul>
                    </div>

                    <transition-group name="fade" tag="div" class="list-wrap"
                                      v-bind:css="false"
                                      v-on:before-enter="beforeEnter"
                                      v-on:enter="enter" appear>

                        <article class="one-formation" :class="{citation: formation.post_type === 'citation'}"
                                 v-for="(formation, index) in selectedFormation" v-if="index < sizeLimit"
                                 :key="formation.key" :data-index="index">

                            <template v-if="formation.post_type === 'formation'">

                                <div>
                                    <p class="titre"><a :href="formation.link">{{formation.title}}</a></p>
                                    <p class="resume" v-html="formation.resume"></p>
                                </div>
                                <div>
                                    <div class="une-ligne calendar" v-if="formation.duree">
                                        <div class="wrap-picto"><img
                                                :src=calendarAsset
                                                alt="Durée"></div>
                                        <div class="wrap-texte" v-html="formation.duree">
                                        </div>
                                    </div>
                                    <div class="une-ligne place" v-if="formation.localisation">
                                        <div class="wrap-picto"><img
                                                :src=placeAsset
                                                alt="Localisation"></div>
                                        <div class="wrap-texte" v-html="formation.localisation">
                                        </div>
                                    </div>
                                    <div class="une-ligne money" v-if="formation.cout">
                                        <div class="wrap-picto"><img
                                                :src=moneyAsset
                                                alt="Financement"></div>
                                        <div class="wrap-texte" v-html="formation.cout">
                                        </div>
                                    </div>
                                    <div class="une-ligne logos" v-if="formation.pastille">
                                        <div class="pastille" v-for="pastille in formation.pastille">
                                            <img :src="getPastilleAsset(pastille)" alt="">{{pastille.label}}
                                        </div>
                                    </div>

                                    <div class="cta">
                                        <a :href="getInscriptionLink(formation.link)" class="btn bleu link" v-html="formation.label"></a>
                                        <a :href="formation.link" class="btn link outline" v-html="formation.more"></a>
                                    </div>
                                </div>

                            </template>

                            <template v-else>

                                <p class="quote-img"><img :src=quoteAsset
                                                          alt="Témoignage">
                                </p>
                                <p>{{formation.la_citation}}</p>
                                <p class="auteur">{{formation.auteur}}</p>
                                <p class="fonction">{{formation.poste_de_lauteur}}</p>

                            </template>

                        </article>
                    </transition-group>

                    <div class="cta list" v-if="sizeLimit < selectedFormation.length">
                        <a href="" @click.prevent="AddMore">de formations</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { filter, map, find } from 'lodash';
    import $ from 'jquery';
    import Sticky from 'sticky-js';
    import { breakpoint, breakpointDown, breakpointUp } from '../libs/Breakpoints';
    import Scrolling from '../libs/Scrolling';
    import AOS from 'aos';

    export default {
        props: {
            formations: {
                type: Array,
                required: true,
            },
            filters: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                initialSizeLimit: 9,
                sizeLimit: null,
                addCount: 7,
                selectedFormation: [],
                offset: 0,
                activeFilter: null,
                firstInit: true,
            };
        },
        watch: {
            activeFilter(newVal) {
                this.updateList(newVal);
            },
        },
        computed: {
            calendarAsset() {
                return `${window.c2c.iquitheme_assets}/images/icons/picto-calendar.png`;
            },
            placeAsset() {
                return `${window.c2c.iquitheme_assets}/images/icons/picto-place.png`;
            },
            moneyAsset() {
                return `${window.c2c.iquitheme_assets}/images/icons/picto-money.png`;
            },
            quoteAsset() {
                return `${window.c2c.iquitheme_assets}/images/icons/picto-quote.png`;
            },
            cpfAsset() {
                return `${window.c2c.iquitheme_assets}/images/logo-cpf.png`;
            },
            certifAsset() {
                return `${window.c2c.iquitheme_assets}/images/logo-certif.png`;
            },
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            getPastilleAsset(pastille) {
                if (pastille.value === 'cpf') {
                    return this.cpfAsset;
                }
                if (pastille.value === 'certif') {
                    return this.certifAsset;
                }
                return null;
            },
            getInscriptionLink(link) {
                return link + '#inscription';
            },
            AddMore() {
                this.sizeLimit += this.addCount;
                setTimeout(() => {
                    this.offset = this.offset + this.addCount;
                    this.AosRefrech();
                }, 100);
            },
            beforeEnter: function (el) {
                $(el).removeClass('show');
                $(el).addClass('hidden');
            },
            enter: function (el, done) {
                var delay = ((el.dataset.index - this.offset) * 150);
                setTimeout(() => {
                    $(el).addClass('show');
                }, delay);

            },
            initFilters() {
                this.activeFilter = this.filters[0].slug;
            },
            selectFilter(Selectedfilter) {
                this.$router.push({ hash: Selectedfilter.slug });
                this.activeFilter = Selectedfilter.slug;
            },
            updateList(Selectedfilter) {

                let goodFilterObj = find(this.filters, (o, index) => {
                    return o.slug === Selectedfilter;
                });

                Selectedfilter = goodFilterObj;

                this.sizeLimit = this.initialSizeLimit;
                this.offset = 0;
                this.selectedFormation = [];
                setTimeout(() => {
                    this.offset = this.sizeLimit;
                }, 1350);

                this.$nextTick(() => {
                    if (!this.firstInit) {
                        Scrolling.scrollTo('#anchorReset', 'easeInOutExpo', 400);
                    }
                    this.firstInit = false;

                    if (Selectedfilter.slug === 'all') {
                        this.selectedFormation = this.formations;
                        this.AosRefrech();
                        return;
                    }

                    this.selectedFormation = filter(this.formations, (o, index) => {

                        let isPresent = false;

                        map(o.terms, function (term) {
                            if (term.slug === Selectedfilter.slug) {
                                isPresent = true;
                            }
                        });

                        return isPresent;
                    });
                    this.AosRefrech();

                });
            },
            stickyFilters() {

                var marginTop = 0;
                if (breakpointDown('md')) {
                    marginTop = Scrolling.hauteurMenuMobile;
                }

                this.filtersSticky = new Sticky('.filters-wrappers', {
                    marginTop: marginTop,
                    stickyClass: 'shadow',
                    wrap: true,
                });
            },
            resizeEndHandle() {
                try {
                    this.cleanSpan(this.filtersSticky);
                } catch (e) {
                }

                try {
                    this.filtersSticky.destroy();
                } catch (e) {
                }

                this.stickyFilters();

            },
            cleanSpan(stickyInstance) {
                stickyInstance.elements.forEach(function (element) {
                    if ($(element).parent().is('span')) {
                        $(element).unwrap();
                    }
                });
            },
            AosRefrech() {
                setTimeout(() => {
                    AOS.refresh();
                }, 300);
            },
            checkStartFilters() {
                if (this.$route.hash) {
                    let slug = this.$route.hash.substring(1);
                    setTimeout(()=>{
                        this.activeFilter = slug;
                    },500)
                }
            },
        },
        created() {
            this.sizeLimit = this.initialSizeLimit;
            this.initFilters();

            setTimeout(() => {
                this.selectedFormation = this.formations;
            }, 100);

            setTimeout(() => {
                this.offset = this.sizeLimit;
            }, 1350);

        },
        mounted() {

            setTimeout(() => {
                this.stickyFilters();
            }, 1000);

            this.AosRefrech();

            this.checkStartFilters();

            $(window).bind('resizeEnd', this.resizeEndHandle);
        },
        beforeDestroy() {

            try {
                this.cleanSpan(this.filtersSticky);
            } catch (e) {
            }

            try {
                this.filtersSticky.destroy();
            } catch (e) {
            }

            $(window).unbind('resizeEnd', this.resizeEndHandle);
        },
    };
</script>
